module.exports = __webpack_public_path__ + "img/logo.bd4c414e.png";